const AMPLITUDE_API_KEY = 'b6baf3bcac14b17808247703f25f541a';
const AMPLITUDE_SDK_VERSION = '2.48.1';

export function initAmplitude() {
	// CC: load the core SDK via CDN script tag (same pattern as session-replay below) so @amplitude/analytics-browser and its sub-packages never enter the webpack build
	const amplitudeScript = document.createElement('script');
	amplitudeScript.src = `https://cdn.amplitude.com/libs/analytics-browser-${AMPLITUDE_SDK_VERSION}-min.js.gz`;
	amplitudeScript.onload = () => {
		const amplitude = (window as any).amplitude;

		amplitude.init(AMPLITUDE_API_KEY, {
			defaultTracking: {
				pageViews: true,
			},
		});

		const sessionReplayScript = document.createElement('script');
		sessionReplayScript.src = 'https://cdn.amplitude.com/libs/session-replay-browser-1.51.5-min.js.gz';
		sessionReplayScript.onload = () => {
			(window as any).sessionReplay.init(AMPLITUDE_API_KEY, {
				deviceId: amplitude.getDeviceId(),
				sessionId: amplitude.getSessionId() || Date.now(),
				sampleRate: 1,
				// Masking level: 'conservative' masks all text and inputs across the app
				privacyConfig: {
					defaultMaskLevel: 'conservative',
					// Completely unrender/block specific sensitive DOM elements by CSS selector
					blockSelector: [],
					// Custom unmasking ONLY for safe, static UI elements (e.g. navigation buttons)
					unmaskSelector: ['.app-sidebar'],
				},
			});
		};
		document.head.appendChild(sessionReplayScript);

		amplitude.add({
			name: 'session-replay-sync',
			type: 'enrichment',
			onSessionIdChanged: async (sessionId) => {
				(window as any).sessionReplay?.setSessionId(sessionId);
			},
		});
	};
	document.head.appendChild(amplitudeScript);
}
